import Backdrop from "@material-ui/core/Backdrop";
import Box from "@material-ui/core/Box";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { BLUE_COLOR } from "../../utils/const";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const SuccessModal = (props) => {
  const handleClose = () => {
    props.open.handleChange(false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.open.value}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.open.value}>
        <Box
          sx={style}
          style={{
            borderRadius: "8px",
            paddingTop: "24px",
            paddingBottom: "24px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          <Typography id="transition-modal-title" variant="h6" component="h2">
            {props.title}
          </Typography>
          <Grid
            style={{
              marginTop: "24px",
              maxHeight: "500px",
              overflow: "scroll",
              borderRadius: "8px",
            }}
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Grid
              style={{ marginTop: "24px" }}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              align="center"
            >
              <Typography
                variant="h6"
                component="h2"
                style={{ color: props.style.successColor }}
              >
                {props.message}
              </Typography>
            </Grid>
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                style={{ marginTop: "48px" }}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <Button
                  onClick={handleClose}
                  style={{
                    color: "#fff",
                    marginRight: "4px",
                    backgroundColor: BLUE_COLOR,
                  }}
                  variant="contained"
                >
                  متوجه شدم
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SuccessModal;
